import { render } from "./ToastComponent.vue?vue&type=template&id=8883c1d8&scoped=true"
import script from "./ToastComponent.vue?vue&type=script&lang=js"
export * from "./ToastComponent.vue?vue&type=script&lang=js"

import "./ToastComponent.vue?vue&type=style&index=0&id=8883c1d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8883c1d8"]])

export default __exports__